import type { AdmView } from '../../api/admDashboard'

/**
 * Cele cinci vederi ale descoperirii, ca o banda in capul fiecareia -
 * `_views.php`.
 *
 * Erau cinci intrari in bara modulului, ceea ce se citea ca cinci subiecte cand
 * e unul singur: ce au gasit scanarile. Sunt tot cinci pagini - fiecare poarta
 * un tabel prea mare ca sa incapa langa celelalte - dar se ajunge la ele de
 * aici, nu din bara.
 *
 * Fiecare are un rand care spune la ce raspunde. Cine n-a mai vazut modulul nu
 * trebuie sa le deschida pe toate ca sa afle care tine intrebarea cu care a
 * venit, iar o fila cu un singur cuvant pe ea nu i-o spune niciodata.
 *
 * LISTA VINE FILTRATA DE PE SERVER, si de doua ori: pe DREPT (un rol caruia i
 * se dau scanarile dar nu si programarea vede patru file, nu o legatura care il
 * refuza) si pe ce s-a MUTAT deja in v4 - o intrare catre un ecran care inca nu
 * exista ar duce intr-un gol, si un gol e mai rau decat o fila care inca nu e
 * acolo.
 *
 * `<a href>`, nu `<Link>`: asa deseneaza si bara modulului din `Shell`, iar
 * caile de aici vin de la server, nu din tipurile ruterului.
 */
export function AdmViews({ views, current }: { views: AdmView[]; current: string }) {
  if (views.length === 0) return null

  return (
    <ul className="adm-views">
      {views.map((view) => (
        <li key={view.url} className={current === view.url ? 'active' : undefined}>
          <a href={`/app/adm/${view.url}`}>
            <span className="adm-view-label">
              <i className={`fas ${view.icon}`}></i> {view.label}
            </span>
            <span className="adm-view-note">{view.note}</span>
          </a>
        </li>
      ))}
    </ul>
  )
}
